import React, { useEffect, useState } from "react";
import { Network, Users } from "lucide-react";
import Modal from "../controls/modal/Modal";
import UserOrgChart from "./UserOrgChart";
import entityDetailsStyles from "../entityDetails/EntityDetails.module.scss";
import clientService from "../../store/services/clients.service";
import portfolioService from "../../store/services/portfolio.service";
import programService from "../../store/services/programs.service";
import projectService from "../../store/services/projects.service";

const serviceByEntityType = {
  client: clientService,
  portfolio: portfolioService,
  program: programService,
  project: projectService,
};

// Resources org chart, opened from a modal (Team card) - mirrors ContactOrgChart's visual style
// but the data comes from the ManagerId reporting line instead of Contact ownership. The Team /
// Hierarchy toggle is a query param on the backend, not a client-side filter, since the two
// scopes fetch structurally different DTOs (a flat team vs one section per node).
const UserOrgChartModal = ({ entityType, entityId, entityName, onClose }) => {
  const [scope, setScope] = useState("Team");
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const service = serviceByEntityType[entityType?.toLowerCase()];
    if (!service || !entityId) return;

    let cancelled = false;
    setIsLoading(true);
    service
      .getOrgChart(entityId, scope)
      .then((response) => {
        if (!cancelled) setData(response);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [entityType, entityId, scope]);

  const htmlTitle = (
    <div className="d-flex align-items-center gap-3">
      <div className="d-flex align-items-center gap-2">
        <Network size={18} color="#342C82" />
        <h4 className="mb-0">Org Chart</h4>
      </div>
      <div className={entityDetailsStyles.viewToggle}>
        <button
          type="button"
          className={`${entityDetailsStyles.viewToggleButton} ${scope === "Team" ? entityDetailsStyles.active : ""}`}
          onClick={() => setScope("Team")}
        >
          <Users size={13} /> Team
        </button>
        <span className={entityDetailsStyles.viewToggleDivider} />
        <button
          type="button"
          className={`${entityDetailsStyles.viewToggleButton} ${scope === "Hierarchy" ? entityDetailsStyles.active : ""}`}
          onClick={() => setScope("Hierarchy")}
        >
          <Network size={13} /> Hierarchy
        </button>
      </div>
    </div>
  );

  return (
    <Modal
      htmlTitle={htmlTitle}
      handleCancel={onClose}
      footer={false}
      size="large"
      resizable
      body={
        <UserOrgChart
          scope={scope}
          data={data}
          isLoading={isLoading}
          currentId={entityId}
          currentName={entityName}
          onNavigate={onClose}
        />
      }
    />
  );
};

export default UserOrgChartModal;
